export default __webpack_public_path__ + "static/media/globe.67a67d16.svg";